module.exports = __webpack_public_path__ + "static/tesla-solar-roof-1-1080w-7db6f7de6f8d66a58b269b1634c379ec.jpg";